import vRouterLink from './RouterLink';

export { vRouterLink };


// WEBPACK FOOTER //
// ./src/appComponents/components/RouterLink/index.js